// extracted by mini-css-extract-plugin
export var container = "_7e-0";
export var icon = "_7e-1";
export var text = "_7e-2";